import { inject, Injectable, InjectionToken } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PopoverController } from '@ionic/angular';
import { DOCUMENT } from '@angular/common';


export function sortByField(key: string, sortOrder: 'forward' | 'reverse' = 'forward') {
  const multiplier = sortOrder  === 'forward' ? 1 : -1;
  return (a: any,b: any) => ((+a[key] || 10000) - (+b[key] || 10000)) * multiplier;
}

export function capitalizeFirstLetter(s: string): string {
  return (s && s[0].toUpperCase() + s.slice(1)) || '';
}

export function parseSiebelDT(siebelDt: string): Date {
  let formattedDT: Date | any = undefined;
  if (!!siebelDt) {
    const m = parseInt(siebelDt.substr(0,2), 10) || 1;
    const d = parseInt(siebelDt.substr(3,2), 10) || 0;
    const y = parseInt(siebelDt.substr(6,4), 10) || 0;
    const h = parseInt(siebelDt.substr(11,2), 10) || 0;
    const mi = parseInt(siebelDt.substr(14,2), 10) || 0;
    const s = parseInt(siebelDt.substr(17,2), 10) || 0;
    formattedDT = new Date(y, m-1, d, h, mi, s);
  }
  return formattedDT;
}

export function replaceApostrophe(value: string): string {
  // eslint-disable-next-line max-len
  const apostrophes = new RegExp(/[\u0027\u0060\u02bb\u02bc\u02BE\u02C8\u02EE\u0301\u0313\u0315\u055A\u05F3\u07F4\u07F5\u1FBF\u2018\u2019\u275B\u275C]/g);
  // const result = value.replace(/\u2019/g, '\''); // -  works
  // const result = value.replace(/[\u2019\u275B\u275C]/g, '\'');  // -  works
  const result = value.replace(apostrophes, '\'').replace(/'{2,}/g, '\'');
  return result || '';
}

export function trimSpaces(value: string): string {
  const result = value.replace(/^\s+|\s+$/g, '').replace(/\s{2,}/g, ' ');
  return result || '';
}


export function  sanitizeSiebelArray(arr: any[] | any): any[] {
  let resultArr: any[] = [];
  if (Array.isArray(arr)) {
    resultArr = arr;
  } else if (arr) {
    resultArr.push(arr);
  }
  return resultArr;
}

export const WINDOW: InjectionToken<Window> = new InjectionToken<Window>(
  'An abstraction over global window object',
  {
    factory: () => {
      const {defaultView} = inject(DOCUMENT);

      if (!defaultView) {
        throw new Error('Window is not available');
      }

      return defaultView;
    }
  }
);

export const NAVIGATOR = new InjectionToken<Navigator>(
  'An abstraction over window.navigator object',
  {
    factory: () => inject(WINDOW).navigator
  },
);

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  private modalCtrl = inject(ModalController);
  private popoverController = inject(PopoverController);

  constructor() { }

  public sanitizeSiebelArray(arr: any[] | any): any[] {
    let resultArr: any[] = [];
    if (Array.isArray(arr)) {
      resultArr = arr;
    } else if (arr) {
      resultArr.push(arr);
    }
    return resultArr;
  }

  public removePhoneMask(maskedValue: string): string {
    return maskedValue.replace(/\s+/g, '');
  }

  public formatPhone(phoneNumber: string): string {
    if (typeof phoneNumber === 'undefined') {
      return '';
    } else {
      phoneNumber = phoneNumber.slice(-10);
      phoneNumber = phoneNumber.replace(/[^\d]/g, '');
      if (phoneNumber.length === 10) {
        return phoneNumber.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3$4');
      }
      return '';
    }
  }

  public formatPhoneNotFull(phoneNumber: string): string {
    if (typeof phoneNumber === 'undefined') {
      return '';
    } else {
      phoneNumber = phoneNumber.slice(-9);
      phoneNumber = phoneNumber.replace(/[^\d]/g, '');
      if (phoneNumber.length === 9) {
        return phoneNumber.replace(/(\d{3})(\d{3})(\d{2})(\d{1})/, '$1 $2 $3$4');
      }
      return '';
    }
  }

  public capitalize(inputValue: string): string {
    let newValue = '';
    let space = false;
    for (let i = 0; i < inputValue.length; i++) {
      let c = inputValue.charAt(i);
      if (c !== ' ' && (i === 0 || space)) {
        c = c.toUpperCase();
        space = false;
      } else if (c === ' ') {
        space = true;
      }
      newValue += c;
    }
    return newValue;
  }

  public async closeAllModal() {
    const topModal = await this.modalCtrl.getTop();
    if (topModal) { await this.dismissAllModal(topModal); }
  }

  public dismissAllModal(modal: HTMLIonModalElement) {
    return new Promise ((resolve) => {
      modal.dismiss().then(async res => {
        const getNewTop = await this.modalCtrl.getTop();
        if (getNewTop) {
          resolve(this.dismissAllModal(getNewTop));
        } else {
          resolve(true);
        }
      });
    });
  }

  public async closeAllPopover() {
    const topModal = await this.popoverController.getTop();
    if (topModal) { await this.dismissAllPopover(topModal); }
  }

  public dismissAllPopover(popover: HTMLIonPopoverElement) {
    return new Promise ((resolve) => {
      popover.dismiss().then(async res => {
        const getNewTop = await this.popoverController.getTop();
        if (getNewTop) {
          resolve(this.dismissAllPopover(getNewTop));
        } else {
          resolve(true);
        }
      });
    });
  }
}
